import colors from '@magoosh/lib/styles/colors.module.scss';

export default (datumName: string, examName: string) => {
  if (examName === 'GMAT') {
    return {
      'Math': colors.dataLightPurple,
      'Quant': colors.dataLightPurple,
      'Quantitative Reasoning': colors.dataLightPurple,
      'Quantitative Reasoning Lessons': colors.dataLightPurple,
      'Quantitative Reasoning Questions': colors.dataDarkPurple,
      'Verbal': colors.dataLightBlue,
      'Verbal Reasoning': colors.dataLightBlue,
      'Verbal Reasoning Lessons': colors.dataLightBlue,
      'Verbal Reasoning Questions': colors.dataDarkBlue,
      'Data': colors.dataLightOrange,
      'Data Insights': colors.dataLightOrange,
      'Data Insights Lessons': colors.dataLightOrange,
      'Data Insights Questions': colors.dataDarkOrange
    }[datumName];
  } else if (examName === 'GRE') {
    return {
      'Math': colors.dataLightPurple,
      'Math Lessons': colors.dataLightPurple,
      'Math Questions': colors.dataDarkPurple,
      'Vocab': colors.dataLightBlue,
      'Verbal': colors.dataLightBlue,
      'Verbal Lessons': colors.dataLightBlue,
      'Verbal Questions': colors.dataDarkBlue
    }[datumName];
  } else {
    return null;
  }
};
